.ux-w-service-calls {
    display: block;

    .ux-w-wrapper__body {
        > div {
            display: flex;
        }
    }

    &__item {
        display: inline-flex;

        &:nth-of-type(even) {
            background: $color-blue-menu-bg;
        }
    }
}
